import { render, staticRenderFns } from "./TripDispatch.vue?vue&type=template&id=65830b06&scoped=true&"
import script from "./TripDispatch.vue?vue&type=script&lang=js&"
export * from "./TripDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65830b06",
  null
  
)

export default component.exports